import { render, staticRenderFns } from "./SimplePhotoProduct.vue?vue&type=template&id=6259c8e4&scoped=true&"
import script from "./SimplePhotoProduct.vue?vue&type=script&lang=js&"
export * from "./SimplePhotoProduct.vue?vue&type=script&lang=js&"
import style0 from "./SimplePhotoProduct.vue?vue&type=style&index=0&id=6259c8e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6259c8e4",
  null
  
)

component.options.__file = "SimplePhotoProduct.vue"
export default component.exports